module.exports = __webpack_public_path__ + "static/media/acams-mara-video-new.f1b08982.mp4";